<template>
  <div class="form-group">
    <!-- <input
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
      v-bind:value="value"
      type="number"
      class="form-control"
      id="number"
      step="0"
    /> -->
    <div class="btn-group btn-group-toggle" data-toggle="buttons">
      <label
        class="btn btn-outline-primary"
        :class="{ active: value == 'left' }"
      >
        <input
          @click.prevent="$emit('input', 'left')"
          v-bind:value="value"
          v-bind="$attrs"
          type="radio"
          name="left"
          id="left"
        />
        <svg
          width="24"
          height="16"
          viewBox="0 0 24 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="1" width="24" height="2" rx="0.5" fill="currentColor" />
          <rect y="9" width="24" height="2" rx="0.5" fill="currentColor" />
          <rect y="5" width="15" height="2" rx="0.5" fill="currentColor" />
          <rect y="13" width="15" height="2" rx="0.5" fill="currentColor" />
        </svg>
      </label>
      <label
        class="btn btn-outline-primary"
        :class="{ active: value == 'center' }"
      >
        <input
          @click.prevent="$emit('input', 'center')"
          v-bind:value="value"
          v-bind="$attrs"
          type="radio"
          name="center"
          id="center"
        />
        <svg
          width="24"
          height="16"
          viewBox="0 0 24 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="1" width="24" height="2" rx="0.5" fill="currentColor" />
          <rect y="9" width="24" height="2" rx="0.5" fill="currentColor" />
          <rect
            x="4"
            y="5"
            width="15"
            height="2"
            rx="0.5"
            fill="currentColor"
          />
          <rect
            x="4"
            y="13"
            width="15"
            height="2"
            rx="0.5"
            fill="currentColor"
          />
        </svg>
      </label>
      <label
        class="btn btn-outline-primary"
        :class="{ active: value == 'right' }"
      >
        <input
          @click.prevent="$emit('input', 'right')"
          v-bind:value="value"
          v-bind="$attrs"
          type="radio"
          name="right"
          id="left"
        />
        <svg
          width="24"
          height="16"
          viewBox="0 0 24 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="1" width="24" height="2" rx="0.5" fill="currentColor" />
          <rect y="9" width="24" height="2" rx="0.5" fill="currentColor" />
          <rect
            x="9"
            y="5"
            width="15"
            height="2"
            rx="0.5"
            fill="currentColor"
          />
          <rect
            x="9"
            y="13"
            width="15"
            height="2"
            rx="0.5"
            fill="currentColor"
          />
        </svg>
      </label>
    </div>

    <!-- <div class="btn-group mr-2" role="group" aria-label="Second group">
      <button
        @click.prevent="$emit('input', 'left')"
        v-bind:value="value"
        v-bind="$attrs"
        type="button"
        class="btn btn-secondary"
      >
        l
      </button>
      <button
        @click.prevent="$emit('input', 'center')"
        v-bind:value="value"
        v-bind="$attrs"
        type="button"
        class="btn btn-secondary"
      >
        c
      </button>
      <button
        @click.prevent="$emit('input', 'right')"
        v-bind:value="value"
        v-bind="$attrs"
        type="button"
        class="btn btn-secondary"
      >
        r
      </button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Aligment",
  inheritAttrs: false,
  props: {
    label: String,
    name: String,
    value: [String, Boolean, Array, Object, Number],
  },
};
</script>

<style>
.btn-outline-primary {
  padding: 7px 20px;
}
</style>